import { html } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { DropdownDialog } from "../DropdownDialog";
import { translate } from "../../../shared/l10n/translate";
import "./GuestSelector";

export class GuestSelectorDialog extends DropdownDialog {
	constructor(anchorNode) {
		super(anchorNode);
		this.node.classList.add("guests-dialog");
	}

	get needed_minimal_height() {
		return 400;
	}

	getTemplateContent() {
		return html`<esc-guest-selector
			.rooms=${structuredClone(this.rooms)}
			max-guests=${this.maxGuests}
			@change=${this.onRoomsChange}
		></esc-guest-selector>`;
	}

	getTemplateFooter() {
		return html`
			<div
				class="dialog__bottom-bar ${classMap({
					"dialog__bottom-bar--show": this.showConfirmButton,
				})}"
			>
				<button
					class="action-button dialog__bottom-bar__button"
					?disabled=${!this.showConfirmButton}
					@click=${this.onConfirmButtonClick}
				>
					${translate("basic_confirm")}
				</button>
			</div>
		`;
	}

	onRoomsChange({ detail }) {
		this.rooms = detail.rooms;
		this.showConfirmButton = true;
		this.render();
	}

	onConfirmButtonClick() {
		this.node.dispatchEvent(
			new CustomEvent("confirm", {
				detail: { rooms: this.rooms },
			}),
		);
		this.hide();
	}

	show(rooms, maxGuests, zIndex) {
		this.showConfirmButton = false;
		this.rooms = rooms;
		this.maxGuests = maxGuests;
		super.show(zIndex);
	}
}
